<template>
    <div class="card">
        <div class="card-header">
            <div class="card-header-title">
                {{ trans.elements.reset_password }}
            </div>
        </div>
        <div class="card-content field-label-container">
            <div v-if="emailSent" class="password-reset-msg">
                <p class="has-text-weight-semibold has-text-success">
                    {{ trans.msg.email_sent }}
                </p>
                <p v-if="isBx24context">
                    {{ trans.msg.reload_page }}
                </p>
            </div>

            <form method="POST" :action="action" v-show="token || !emailSent"
                  @submit.prevent="submit" @input="clearValidation" novalidate
            >
                <slot><!--CSRF token--></slot>

                <div class="field is-horizontal">
                    <label for="email" class="field-label is-normal">
                        {{ trans.elements.email }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input id="email" type="email" name="email" v-model="form.email"
                                       class="input" :class="[errors.email ? 'is-danger' : '']"
                                       required autocomplete="email" autofocus
                                >
                            </div>
                            <p v-show="errors.email" class="help is-danger">
                                {{ errors.email }}
                            </p>
                        </div>
                    </div>
                </div>

                <div v-if="token" class="field is-horizontal">
                    <label for="password" class="field-label is-normal">
                        {{ trans.elements.password }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input id="password" type="password" name="password" v-model="form.password"
                                       class="input" :class="[errors.password ? 'is-danger' : '']"
                                       required autocomplete="new-password"
                                >
                            </div>
                            <p v-show="errors.password" class="help is-danger">
                                {{ errors.password }}
                            </p>
                        </div>
                    </div>
                </div>

                <div v-if="token" class="field is-horizontal">
                    <label for="password-confirm" class="field-label is-normal">
                        {{ trans.elements.confirm_password }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input id="password-confirm" type="password"
                                       class="input" :class="[errors.password ? 'is-danger' : '']"
                                       name="password_confirmation" autocomplete="new-password"
                                       v-model="form.password_confirmation" required
                                >
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <label class="field-label"></label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <button type="submit" class="button is-info"
                                        :class="[isLoading ? 'is-loading' : '']"
                                        :disabled="isLoading"
                                >
                                    {{ token ? trans.elements.reset_button : trans.elements.send_reset_link }}
                                </button>
                                <a :href="cancel_route" class="button is-outlined">
                                    {{ trans.elements.cancel }}
                                </a>
                            </div>
                        </div>
                        <p v-show="errors.unexpected || errors.token" class="help is-danger">
                            {{ errors.unexpected || errors.token }}
                        </p>
                    </div>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
    import { axiosForm } from '../mixins/axiosFormMixin.js';

    export default{
        mixins: [axiosForm],
        props: {
            token: String,
            email: String,
            isBx24context: Boolean,
        },
        data() {
            return {
                emailSent: false,
                form: {
                    email: this.email,
                    token: this.token,
                    password: null,
                    password_confirmation: null
                },

                okReport: 'Пароль сброшен',
                failReport: 'Ошибка сброса пароля',
            }
        },
        methods: {
            postResultHandler(response) {
                let firstStep = !this.token;

                if (response.status === 200) {
                    let responseUrl = response.request.responseURL;

                    // Если шаг 1 (запрос отправки Email для сброса)
                    if (firstStep) {
                        // Сообщаем пользователю об отправке Email
                        this.emailSent = true;

                        // Если шаг 2 (запрос сброса пароля)
                    } else {
                        let resetIsDone = !responseUrl.includes(this.action);

                        if (resetIsDone) {
                            window.location.replace(responseUrl);
                        } else {
                            this.errors.unexpected = this.trans.msg.unexpected_error;
                        }
                    }
                }
            }
        }
    }
</script>
